import { createSelector } from 'reselect';
import { INIT_STATE } from './constants';
import type { QrCodeSettings } from '../../../../../shared/types';
import { getCurrentApp } from 'client/js/main/selectors/AppSelectors';
import type { RootState } from 'client/js/redux';
import type { App } from 'client/js/common/types/appTypes';
import type { AppStoreState } from './types';

export const selectAppStoreState = (state: RootState): AppStoreState => {
  return state.appStore || INIT_STATE;
};

export const selectAndroidAppName = createSelector<RootState, AppStoreState, string | undefined>(
  selectAppStoreState,
  (appStore) => {
    return appStore.androidAppName;
  }
);

export const selectIosAppName = createSelector<RootState, AppStoreState, string | undefined>(
  selectAppStoreState,
  (appStore) => {
    return appStore.iosAppName;
  }
);

export const selectAndroidAppIdentifier = createSelector<RootState, App, string>(
  getCurrentApp as any,
  (currentApp: App | null | undefined) => {
    const { android_url, default_android_url, web_url } = currentApp as App;

    return android_url || default_android_url || web_url || '';
  }
);

export const selectIosAppIdentifier = createSelector<RootState, App, string>(
  getCurrentApp as any,
  (currentApp: App | null | undefined) => {
    const { ios_url, default_ios_url, web_url } = currentApp as App;

    return ios_url || default_ios_url || web_url || '';
  }
);

export const selectDesktopAppUrl = createSelector<RootState, App, string>(
  getCurrentApp as any,
  (currentApp: App | null | undefined) => {
    const { desktop_url, default_desktop_url, web_url } = currentApp as App;

    return desktop_url || default_desktop_url || web_url || '';
  }
);

export const selectQrCodeSettings = createSelector<RootState, AppStoreState, QrCodeSettings | undefined>(
  selectAppStoreState,
  (appStore) => {
    return appStore.qrCodeSettings;
  }
);
